var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavorites(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5521",
    "data-name": "Raggruppa 5521",
    transform: "translate(-186 -441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5518",
    "data-name": "Raggruppa 5518",
    transform: "translate(186 441)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2115",
    "data-name": "Rettangolo 2115",
    width: 24,
    height: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Unione_1",
    "data-name": "Unione 1",
    d: "M16.618,21.189,9,16.1,1.388,21.189a.857.857,0,0,1-.916.037A.924.924,0,0,1,0,20.415V3.085A3.02,3.02,0,0,1,.975.875,3.269,3.269,0,0,1,3.212,0H14.788a3.268,3.268,0,0,1,2.241.875A3,3,0,0,1,18,3.085v17.33a.923.923,0,0,1-.47.81.816.816,0,0,1-.427.115A.858.858,0,0,1,16.618,21.189Z",
    transform: "translate(189 442)",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorites);
export default __webpack_public_path__ + "static/media/favorites.f28830223ea66fb03593c6653d71a363.svg";
export { ForwardRef as ReactComponent };